// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__-WIH5","dangerText":"style_dangerText__s1ofq","hintWrapper":"style_hintWrapper__4fi1Q"};